
/**
 * 检测车牌号格式
 * @param licensePlate
 * @returns {RegExpMatchArray}
 */
const checkLicensePlate = (licensePlate) => {
    if (!licensePlate)
        return false;

    // 所有地区的车牌简称
    const validProvinces = '京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁无';
    // 判断第一个字是否为有效的车牌简称
    const provinceChar = licensePlate.charAt(0);
    if (!validProvinces.includes(provinceChar)) {
        return validProvinces.length > 2; //非大陆车，超过2位即可
    }

    if (provinceChar == '无') {
        // 新车无牌车
        return true;
    }

    // 正则表达式匹配车牌号格式
    const regex = /^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁港澳][A-Z][A-Z0-9]{4,5}[A-Z0-9挂学警港澳]?$/;
    return regex.test(licensePlate);
}

/**
 * 是否临时车牌号？
 * @param {any} licensePlate
 * @returns
 */
const isTempLicenseNo = (licensePlate) => {
    return licensePlate.includes('无');
}

/**
 * 获取临时号码
 * @param {any} licensePlate
 * @returns
 */
const getTempLicenseNo = (licensePlate) => {
    return licensePlate.replace('无', '');
}

const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

//转年月日
function transformDay(time) {
    let today = new Date(time);
    let oYear = today.getFullYear();
    let oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    let oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    return oYear + '年' + oMoth + '月' + oDay + '日';
}

function transformDay2(time) {
    let today = new Date(time);
    let oYear = today.getFullYear();
    let oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    let oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    let h = today.getHours() < 10 ? '0' + today.getHours() + ':' : today.getHours() + ':';
    let m = today.getMinutes() < 10 ? '0' + today.getMinutes() + ':' : today.getMinutes() + ':';
    let s = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds();
    return oYear + '年' + oMoth + '月' + oDay + '日' + ' ' + h + m + s;
}

function transformDay3(time) {
    var today = new Date(time);
    var oYear = today.getFullYear();
    var oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    var oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    return oYear + '-' + oMoth + '-' + oDay;
}

//将时间戳转换成正常时间格式
function timestampToTime(timestamp, isdate) {
    let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '/';
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate();
    if (isdate)
        return Y + M + D;
    D += ' ';
    let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

//num -1:昨天，1:明天, str是分割号
function getDay(num, str, time) {
    let today = time ? new Date(time) : new Date();
    let nowTime = today.getTime();
    let ms = 24 * 3600 * 1000 * num;
    today.setTime(parseInt(nowTime + ms));
    let oYear = today.getFullYear();
    let oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    let oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    return oYear + str + oMoth + str + oDay;
}

/**
 * 深层拷贝
 * @param {对象} initalObj
 */
const deepClone = function (initalObj) {
    let obj = {};
    obj = JSON.parse(JSON.stringify(initalObj));
    return obj;
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

/**
 * 名称校验
 * @param {名称} value
 */
function isName(value) {
    if (!/^[\u4e00-\u9fa5]{2,6}$/.test(value)) {
        return false
    }
    else {
        return true
    }
}

/**
 * 公司名称校验
 * @param {名称} value
 */
function isCompanyName(value) {
    if (!/^[A-Za-z\u4E00-\u9FA5]{2,20}$/.test(value)) {
        return false
    }
    else {
        return true
    }
}

/**
 * 手机号码校验
 * @param {手机号码} value
 */
function isPhone(value) {
    if (!/^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\d{8}$/.test(value)) {
        return false;
    }
    else {
        return true;
    }
}

/**
 * 车牌号码校验
 * @param {车牌号} str
 */
function isLicenseNo(vehicleNumber) {
    let xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
    let creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
    if (vehicleNumber.length == 7) {
        return creg.test(vehicleNumber);
    }
    else if (vehicleNumber.length == 8) {
        return xreg.test(vehicleNumber);
    }
    else {
        return false;
    }
}

// 车辆识别代码校验
function isCarVin(value) {
    if (!/^[0-9A-Za-z]{1,17}$/.test(value)) {
        return false
    }
    else {
        return true
    }
}

// 发动机号校验
function isEngineNo(value) {
    return /^[0-9A-Za-z\-\u4e00-\u9fa5]{1,20}$/.test(value);
}

//邮箱校验
function isEmail(value) {
    return /^\w+((-\w+)|(\.\w+))*[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value);
}

//营业执照校验
function isLicense(value) {
    if (!/(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/.test(value)) {
        return false
    }
    else {
        return true
    }
}

/**
 * 身份证校验粗略版
 * @param {身份证号码} value
 */
function isCard(value) {
    if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return false
    }
    else {
        return true
    }
}

function jsToFormData(name, data) { //对象转formdata格式
    let formData = '';
    for (let i in data) {
        let item = data[i];
        for (let d in item) {
            let key = d; // 属性名name 
            let value = item[key]; //属性值gao
            if (formData == '')
                formData += `${name}[${i}].${key}=${value}`
            else
                formData += `&${name}[${i}].${key}=${value}`
        }
    }
    return formData;
}

/**
 * 对象转表单格式
 * @param {参数} object1
 */
function objectToFormData(name, object) {
    if (typeof object != 'object' || object == null)
        return object;

    let obj = "";
    const keys = Object.keys(object);
    for (let index = 0; index < keys.length; index++) {
        let value = "";
        const item = object[keys[index]];
        if (typeof item != 'object')
            value = `${name}.${keys[index]}=${item}`;
        else if (item)
            value = objectToFormData(`${name}.${keys[index]}`, item);
        else
            value = `${name}.${keys[index]}=`;
        if (obj === "")
            obj = value;
        else
            obj += "&" + value;
    }
    return obj;
}

function toFormData(prefix, obj) {
    if (!isObject(obj)) return obj;

    if (prefix) prefix = `${prefix}.`;//前缀

    let result = new Array();
    let keys = Object.keys(obj);
    keys.forEach(key => {
        toFormDataItem(prefix, key, obj[key], result);
    });

    return result.join('&');
}

function toFormDataItem(prefix, key, val, result) {
    if (!isObject(val)) {
        if (val) val = val.toString().replace(/&/g, "＆");//替换特殊字符＆
        result.push(`${prefix}${key}=${val}`);
        return;
    }

    if (val instanceof Array) {
        for (let index = 0; index < val.length; index++) {
            let item = val[index];
            let keys = Object.keys(item);
            keys.forEach(_key => {
                toFormDataItem(prefix, `${key}[${index}].${_key}`, item[_key], result);
            });
        }
    }
    else if (isObject(val)) {
        let keys = Object.keys(val);
        keys.forEach(_key => {
            toFormDataItem(prefix, `${key}.${_key}`, val[_key], result);
        });
    }
}

//截取url的参数
function getQueryVariable(variable) {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}


function getUriParameters(strParamName) {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    return params.get(strParamName);
}

Date.prototype.format = function (formatStr) {
    let str = formatStr;
    let Week = ['日', '一', '二', '三', '四', '五', '六'];
    str = str.replace(/yyyy|YYYY/, this.getFullYear());
    str = str.replace(/MM/, (this.getMonth() + 1) > 9 ? (this.getMonth() + 1).toString() : '0' + (this.getMonth() + 1));
    str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
    str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
    str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
    str = str.replace(/ss/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
    str = str.replace(/dw/, '星期' + Week[this.getDay()]);
    str = str.replace(/zw/, '周' + Week[this.getDay()]);
    let ms = this.getMilliseconds();
    if (ms < 10) {
        ms = '00' + this.getMilliseconds();
    }
    else if (ms < 100) {
        ms = '0' + this.getMilliseconds();
    }
    else {
        ms = this.getMilliseconds();
    }
    str = str.replace(/fff/, ms);
    return str;
}

/**
 * 转化月份为开始时间和结束时间
 * @param date
 * @returns {{startTime: Date, endTime: Date}}
 * @constructor
 */
function monthToStartEndTime(date) {
    let nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    let endTime = new Date(nextMonth - 1);
    return {
        startTime: date,
        endTime: endTime
    };
}

function isToday(date) {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始，所以要加1
    const day = today.getDate();

    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth() + 1;
    const dateDay = date.getDate();

    // 判断年月日是否完全相同
    return year === dateYear && month === dateMonth && day === dateDay;
}

//阿拉伯数字转为中文数字
function numToChinese(num) {
    // 输入验证
    if (!/^-?\d*\.?\d+$/.test(num)) return "请输入有效的数字";

    // 分离整数部分和小数部分
    let [integerPart, decimalPart = ''] = Math.abs(num).toString().split('.');
    let isNegative = num < 0;
    let result = '';

    // 处理整数部分的函数
    function convertInteger(strNum) {
        if (strNum === '0') return '零';

        const chineseDigits = ['零', '一', '两', '三', '四', '五', '六', '七', '八', '九'];
        const units = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千'];

        let len = strNum.length;
        let result = '';

        for (let i = 0; i < len; i++) {
            let digit = parseInt(strNum[i]);
            let unitIndex = len - 1 - i;

            // 处理零
            if (digit === 0) {
                if (result.slice(-1) !== '零' && unitIndex % 4 !== 0) {
                    result += '零';
                }
                continue;
            }

            result += chineseDigits[digit] + units[unitIndex];
        }

        // 处理特殊情况
        if (result.startsWith('一十')) {
            result = result.slice(1);
        }

        // 处理万和亿
        if (len > 8) {
            let billion = Math.floor(strNum / 100000000);
            let rest = strNum % 100000000;
            let billionStr = convertInteger(billion.toString()) + '亿';
            let restStr = rest ? convertInteger(rest.toString()) : '';
            result = billionStr + restStr;
        }
        else if (len > 4) {
            let tenThousand = Math.floor(strNum / 10000);
            let rest = strNum % 10000;
            let tenThousandStr = convertInteger(tenThousand.toString()) + '万';
            let restStr = rest ? convertInteger(rest.toString()) : '';
            result = tenThousandStr + restStr;
        }

        // 清理多余的零
        return result.replace(/零+/g, '零').replace(/零$/, '') || '零';
    }

    // 处理整数部分
    result = convertInteger(integerPart);

    // 处理负数
    if (isNegative) {
        result = '负' + result;
    }

    // 处理小数部分
    if (decimalPart) {
        result += '点';
        const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        for (let digit of decimalPart) {
            result += chineseDigits[parseInt(digit)];
        }
    }

    return result;
}

function replaceTemplateVariable(text, varName, varValue) {
    var pattern = new RegExp('\\[' + varName + '\\]', "g");
    return text.replace(pattern, varValue);
}

function getHoursDiff(startTime) {
    // 当前时间
    const now = new Date();
    // 目标时间（格式：2025/01/01 01:00:10）
    const target = new Date(startTime.replace(/\//g, '-'));

    // 计算时间差（毫秒）
    const diffMs = now - target;

    // 转换为小时（保留两位小数）
    const diffHours = (diffMs / (1000 * 60 * 60)).toFixed(2);

    return diffHours;
}

function validateVehiclePlate(plateNumber) {
    // 移除所有空格和特殊字符
    // plateNumber = plateNumber.replace(/[\s\-]/g, '').toUpperCase();

    // 蓝牌、黄牌、黑牌（普通燃油车）
    const bluePlateReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{5}$/;

    // 小型新能源车牌（绿牌）
    const smallNewEnergyReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}[DF]{1}[A-HJ-NP-Z0-9]{5}$/;

    // 大型新能源车牌（绿牌）
    const largeNewEnergyReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{5}[DF]{1}$/;

    // 港澳入出境车牌（内地与港澳跨境车牌）
    const crossBorderReg = /^[粤]{1}[Z]{1}[A-HJ-NP-Z0-9]{4}[港澳]{1}$/;

    // 澳门本地车牌（M/AA开头 + 数字）
    const macauLocalReg = /^(M|AA)[0-9]+$/;

    // 香港本地车牌（非M/AA开头的字母数字组合）
    const hongKongLocalReg = /^[A-Z0-9]+$/;

    // 使领馆车牌
    const embassyReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}[领]{1}[0-9]{4}$/;

    // 教练车牌
    const coachReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}[0-9]{4}[学]{1}$/;

    // 武警车牌
    const armedPoliceReg = /^[WJ]{2}[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[0-9]{5}$/;

    // 军车牌
    const militaryReg = /^[A-HJ-NP-Z]{1}[A-HJ-NP-Z0-9]{5}$/;

    if (bluePlateReg.test(plateNumber)) {
        return '普通燃油车蓝牌'
    }
    else if (smallNewEnergyReg.test(plateNumber) || largeNewEnergyReg.test(plateNumber)) {
        return '新能源绿牌'
    }
    else if (crossBorderReg.test(plateNumber)) {
        return '港澳入出境车牌'
        // 然后判断澳门本地车牌（M/AA开头）
    }
    else if (macauLocalReg.test(plateNumber)) {
        return '澳门本地车牌'
        // 最后判断香港本地车牌（其他情况）
    }
    else if (hongKongLocalReg.test(plateNumber)) {
        return '香港本地车牌'
    }
    else if (embassyReg.test(plateNumber)) {
        return '使领馆车牌'
    }
    else if (coachReg.test(plateNumber)) {
        return '教练车牌'
    }
    else if (armedPoliceReg.test(plateNumber)) {
        return '武警车牌'
    }
    else if (militaryReg.test(plateNumber)) {
        return '军车牌'
    }
    else {
        return '无效车牌'
    }
}


/**
 * 获取距离下一个春节还有多少天
 * @returns {Object} { days: Number, date: Date, year: Number }
 */
function getDaysToNextSpringFestival() {
    const today = new Date();
    // 预先查好的春节日期（公历）：键为年份，值为 "YYYY-MM-DD"
    const springFestivals = {
        2025: '2025-01-29',
        2026: '2026-02-17',
        2027: '2027-02-06',
        2028: '2028-01-26',
        2029: '2029-02-13',
        2030: '2030-02-03',
        2031: '2031-01-23',
        2032: '2032-02-11',
        2033: '2033-01-31',
        2034: '2034-02-19',
    };

    const currentYear = today.getFullYear();
    let targetDate = null;
    let targetYear = null;

    // 从今年开始往后找第一个未过的春节
    for (let year = currentYear; year <= 2034; year++) {
        const dateStr = springFestivals[year];
        if (!dateStr) continue;
        const date = new Date(dateStr);
        // 注意：Date 比较会包含时间，所以重置为当天 00:00:00 更安全
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const festivalStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (festivalStart >= todayStart) {
            targetDate = festivalStart;
            targetYear = year;
            break;
        }
    }

    if (!targetDate) {
        throw new Error('超出预设春节年份范围（2025–2034）');
    }

    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return {
        days: diffDays > 0 ? diffDays : 0,
        date: targetDate,
        year: targetYear,
    };
}

export let utils = {
    formatTime,
    transformDay,
    transformDay2,
    transformDay3,
    timestampToTime,
    getDay,
    deepClone,
    isName,
    isCompanyName,
    isPhone,
    isLicenseNo,
    isCarVin,
    isEngineNo,
    isEmail,
    isLicense,
    isCard,
    jsToFormData,
    objectToFormData,
    toFormData,
    getQueryVariable,
    getUriParameters,
    numToChinese,
    replaceTemplateVariable,
    monthToStartEndTime,
    checkLicensePlate,
    isTempLicenseNo,
    getTempLicenseNo,
    isToday,
    getHoursDiff,
    validateVehiclePlate,
    getDaysToNextSpringFestival
}